import styled from "styled-components";

export const TopWrapper = styled.div`
    position: relative;
    height: 484px;
    background-image: url("${(props) => props.bgImage}");
    background-repeat: no-repeat;
    background-position: top center;
    background-color: #010c42;
    .zt {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    .logo {
        position: absolute;
        left: 50%;
        top: 5%;
        margin-left: 445px;
    }
    @media screen and (max-width: 750px) {
        height: 230px;
        .zt {
            width: 90%;
        }
        .logo {
            width: 15%;
            left: 5%;
            margin-left: 0;
        }
    }
`;
